



import {Component, Vue} from 'vue-property-decorator';
import Sidebar from "@/views/layout/main/sidebar/Sidebar.vue";
import MainHeader from "@/views/layout/main/main-header/MainHeader.vue";
import MainFooter from "@/views/layout/main/main-footer/MainFooter.vue";

Component.registerHooks([
  "beforeRouteUpdate"
]);

@Component({
  components: {Sidebar, MainHeader, MainFooter}
})
export default class MainLayout extends Vue {
  private isShowSidebar = false
  private checkShowFooter = true
  private currentRoute = ''

  private created(): void {
    this.currentRoute = this.$route.name || ''
    this.handlerShowFooter()

    let customVH = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', customVH + 'px')
    window.addEventListener('resize', () => {
      let customVH = window.innerHeight * 0.01
      document.documentElement.style.setProperty(
        '--vh',
        customVH + 'px',
      )
    })
  }

  private onClickToMenu(): void {
    this.isShowSidebar = true
  }

  private hiddenSidebar(): void {
    this.isShowSidebar = false
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    this.currentRoute = to.name
    this.handlerShowFooter()
    next()
  }

  private handlerShowFooter(): void {
    if (['routes.setting', 'routes.change.user.info', 'routes.new.baby', 'routes.search.result', 'routes.error.notFound', 'routes.error.internalServerError'].includes(this.currentRoute)) {
      this.checkShowFooter = false
    } else {
      this.checkShowFooter = true
    }
  }
}
